import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import eventsAPI from "../api/eventsAPI";

// Signup component handles the signup process, including validating the input data and submitting a request to the server.
//  If the signup is successful, it redirects the user to the login page.
//  If the signup fails, it displays an error message to the user.
//  The component also renders a form for the user to input their email and password.
//  The form includes two buttons, one to submit the form and one to go back to the login page.
//  The component also renders a link to the login page if the user already has an account.
const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  //   Handles the form submission by sending a POST request to the server with the
  //   user's email and password. If the request is successful, it redirects the user
  //   to the login page. If the request fails, it displays an error message.
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords not matched");
      return;
    }

    try {
      const response = await eventsAPI.post("/login/add", {
        email,
        password,
      });

      if (response.status === 200) {
        // localStorage.setItem('token', data.token);
        // toast.success('Signup successful! Please login.');
        if (response.data.emailExists) {
          setError("Email already exists");
        } else {
          navigate(`/register/${response.data.id}`);
        }
      } else {
        setError("Signup failed");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="signup-page">
      <div className="heading-section">
        <h1>SIGNUP PAGE</h1>
      </div>
      <main className="main">
        <div className="left-side"></div>
        <div className="right-side">
          <form onSubmit={handleSubmit}>
            <div className="btn-group">
              <button type="button" className="btn">
                <img
                  className="logo"
                  src="https://github.com/ecemgo/mini-samples-great-tricks/assets/13468728/d1c98974-c62d-4071-8bd2-ab859fc5f4e9"
                  alt=""
                />
                <span>Sign up with Google</span>
              </button>
              <button type="button" className="btn">
                <img className="logo" src="./facebook_icon.png" alt="" />
                <span>Sign up with Apple</span>
              </button>
            </div>
            <div className="or">OR</div>
            <label htmlFor="email">Email</label>
            <input
              type="text"
              placeholder="Enter Email"
              name="email"
              value={email}
              className="input"
              onChange={(e) => setEmail(e.target.value)}
              //required
            />
            <label htmlFor="password">Password</label>
            <input
              type="password"
              placeholder="Enter Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              //required
            />
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm Password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              //required
            />
            {error && <div className="error">{error}</div>}
            <button type="submit" className="login-btn">
              Next
            </button>
            <div className="links">
              <Link to="/login" className="lower-text">
                Already have an account? <span>Log In</span>
              </Link>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Signup;
